import { ESearchBlockViewActionType, TSetSearchBlockView } from './types';
import { ESearchBlockView } from '../../types/searchBlockView';

export function setSearchBlockView(view: ESearchBlockView): TSetSearchBlockView {
  return {
    type: ESearchBlockViewActionType.SetSearchBlockView,
    payload: view,
  };
}
